import { render, staticRenderFns } from "./FormRemitente.vue?vue&type=template&id=9e9e1338"
import script from "./FormRemitente.vue?vue&type=script&lang=js"
export * from "./FormRemitente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports